import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { size, weight } from "@clockwise/web-commons/src/styles/type.styles";
import { greys, colors } from "@clockwise/web-commons/src/styles/color.styles";

import { cardContainer } from "@components/card/asCard.styles";

export const avatarWidth = 50;

const container: CSSProperties = {
  ...cardContainer,
  padding: 12,
};

const content: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-between",
};

const left: CSSProperties = {
  flex: 0,
};

const right: CSSProperties = {
  flex: 1,
};

const nameContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const h2: CSSProperties = {
  margin: "0 10px",
  fontWeight: weight.bold,
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  width: 160,
  fontSize: 14,
};

const chevron: CSSProperties = {
  color: greys.slate,
};

const status: CSSProperties = {
  margin: "4px 10px 12px",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  flexDirection: "row",
};

const row: CSSProperties = {
  margin: "6px 10px 0",
  display: "flex",
  alignItems: "center",
};

const cardLink: CSSProperties = {
  fontWeight: "bold",
  fontSize: 12,
  color: colors.green.darker,
  textTransform: "uppercase",
  cursor: "pointer",
  marginRight: 15,
  "&:hover": {
    textDecoration: "underline",
  },
};

const disabledLink: CSSProperties = {
  color: greys.slate,
  cursor: "unset",
  "&:hover": {
    textDecoration: "none",
  },
};

const timeZone: CSSProperties = {
  color: greys.slate,
  fontSize: size.md,
};

const gatedMessage: CSSProperties = {
  color: greys.slate,
  fontSize: size.md,
  marginBottom: 10,
  lineHeight: 1.2,
};

const inviteButton: CSSProperties = {
  boxShadow: "none",
};

export const styles = {
  container,
  content,
  left,
  right,
  nameContainer,
  h2,
  chevron,
  row,
  status,
  cardLink,
  disabledLink,
  timeZone,
  gatedMessage,
  inviteButton,
};
